/** A referential list: no tenant, no parameter. */
class FetchSubjectTypeIcons {
	constructor() {
		Object.freeze(this);
	}
}

export default FetchSubjectTypeIcons;
